import * as React from 'react';
import type { AssetId } from 'owa-timestream-store';
import { AssetViewBase } from 'owa-timestream-asset-sdk';
import { observer } from 'mobx-react-lite';
import useTimeStreamAssetViewState from '../util/useTimeStreamAssetViewState';

export default observer(function TimeStreamAssetView({ assetId }: { assetId: AssetId }) {
    const { assetAttributes, CanvasView } = useTimeStreamAssetViewState(assetId);

    return CanvasView ? (
        <AssetViewBase assetId={assetId} View={CanvasView} assetAttributes={assetAttributes} />
    ) : null;
});
